
export interface Impuesto {
  Nombre: string;
  Valor: number;
  Texto: string;
}

export const IMPUESTO_IVA: Impuesto = {
  Nombre: "IVA",
  Valor: 1.21,
  Texto: "IVA (21%)",
};

export const IMPUESTO_IGIC: Impuesto = {
  Nombre: "IGIC",
  Valor: 1.07,
  Texto: "IGIC (7%)",
};

export const determinarImpuesto = (codigoPostal: string | null | undefined): Impuesto => {
  const IGIC_CODIGOS_POSTALES = ["38", "35"];

  if (codigoPostal == null || codigoPostal === "") {
    return IMPUESTO_IVA;
  }

  if (IGIC_CODIGOS_POSTALES.some((prefix) => codigoPostal.startsWith(prefix))) {
    return IMPUESTO_IGIC;
  }

  return IMPUESTO_IVA;
};
